import React from "react";
import { styled } from "@mui/system";
import { useIntl } from "react-intl";
import { Typography } from "@mui/material";
import { LocalizedLink as Link } from "gatsby-theme-i18n"
import PortraitIcon from '@mui/icons-material/Portrait';
import ArticleIcon from '@mui/icons-material/Article';

const TitleHit = styled(Typography)({
	position: "relative",
  width: '90%',
	fontSize: "16px",
	margin: '5px auto',
	wordWrap: 'break-word',
})

const DivIL = styled('li')({
	display:"block",
	cursor: 'pointer',
	transition: '0.2s',
	color: "#6c6c6c",
	'&:hover, &.Mui-focusVisible': {
		color: "black",
		backgroundColor: "#47d2ff",
	}
})

const Linkdiv = styled(Link)({
	textDecoration: "none !important",
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	color: "unset",
	height: "40px"
})

const Clickdiv = styled('div')({
	textDecoration: "none !important",
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	color: "unset",
	height: "40px"
})

const HitComps = ({hit, handleClick}) => {
  const intl = useIntl()
	
	
	const chooseIcon = {
		"portrait": <PortraitIcon style={{fontSize: "30px", margin: "0px 20px"}}/>,
		"event": <ArticleIcon style={{fontSize: "30px", margin: "0px 20px"}}/>
	}

	if (typeof window !== "undefined"
	&& ((window.location.pathname.includes("/frise") && hit.type === "event")
	|| (window.location.pathname.includes("/portrait") && hit.type === "portrait"))){
		return (
			<DivIL>
				<Clickdiv onClick={() => handleClick(hit, "click")}>
					{chooseIcon[hit.type]}
					<TitleHit variant="h6">
						{hit.translations.find((trans) => (trans.lang === intl.locale)).title}
					</TitleHit>
				</Clickdiv>
			</DivIL>
		)
	} else {
		return (
			<DivIL>
				<Linkdiv to={`/${(hit.type === "event")? "frise" : "portrait"}/${hit.slug}`} onClick={() => handleClick(hit, "link")}>
					{chooseIcon[hit.type]}
					<TitleHit variant="h6">
						{hit.translations.find((trans) => (trans.lang === intl.locale)).title}
					</TitleHit>
				</Linkdiv>
			</DivIL>
		)
	}
}

export default HitComps